import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.js';
import 'flag-icon-css/css/flag-icon.min.css';
import "font-awesome/css/font-awesome.min.css";
import './assets/css/colors.css';
import "normalize.css";
import './assets/css/fonts.css';
import "./index.css";
import './assets/css/twist-ui.css';
import './assets/css/modals.css';

import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { initReactI18next } from "react-i18next";
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import FallBack from "./components/fallBack/FallBack";
import Layout from "./Layout";
import store from './redux/store';

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['ar', 'en', 'fr'],
    fallbackLng: 'ar',
    debug: false,
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/assets/locales-cache-hash-5/ar/translation.json',
    },
    react: { 
      useSuspense: false
    }
  })


ReactDOM.render(
  <Provider store={store}>
    {/* <Suspense fallback={<FallBack />}> */}
      <BrowserRouter>
        <Layout>
          <App />
        </Layout>
      </BrowserRouter>
    {/* </Suspense> */}
  </Provider>,
  document.getElementById('root')
);

